{
  "en": {
    "feature_descriptions": {
      "aftercare_customer_feedback": "Client needs to turn this on under organisation settings",
      "aftercare_customer_issue_creation": "Client needs to turn this on within the aftercare module",
      "decisions_core": "Includes simple proposals (without gross offer and other financials), signatures",
      "decisions_financials": "Includes gross offer, net offer, budget, surcharge, negative surcharge allowed",
      "decisions_financials_extended": "Includes extra budget, margin budget and margin extra budget",
      "decisions_proposals_multiple_approval": "Allows the approval of multiple proposals",
      "email_forwarding_project": "Only for MUPs",
      "information_full": "Includes all information fields (e.g. unit specifications, prices, etc)",
      "workflows_full": "Higher tier: workflows with everything (decisions, surveys, installments, news)",
      "workflows_milestones": "Lowest tier: milestones without workflows",
      "workflows_tasks": "Mid tier: workflows with tasks"
    },
    "features": {
      "aftercare": "Aftercare",
      "aftercare_customer_feedback": "Aftercare: request customer approval",
      "aftercare_customer_issue_creation": "Aftercare: customer can create issues",
      "ai_assistant": "AI Assistant",
      "announcements": "News",
      "conversation_mentions": "Conversation: notes and mentions",
      "customers": "Information: multiple customers per unit",
      "decisions_core": "Decisions: Core",
      "decisions_documents": "Decisions: documents",
      "decisions_financials": "Decisions: financials",
      "decisions_financials_extended": "Decisions: financials extended",
      "decisions_partners": "Decisions: partners",
      "decisions_proposals_multiple_approval": "Decisions: multiple proposals approval",
      "decisions_reminders": "Decisions: reminders",
      "decisions_tickets": "Decisions: conversations",
      "document_categories": "Documents: custom categories",
      "documents": "Documents",
      "email_forwarding_client": "Email Forwarding: client",
      "email_forwarding_project": "Email Forwarding: project",
      "employee_import_customers": "Import: Customers (Employee)",
      "employee_import_spaces": "Import: Spaces (Employee)",
      "employee_import_units": "Import: Units (Employee)",
      "faqs": "FAQs",
      "financials": "Financials",
      "information_full": "Information: RED forms",
      "inspirations": "Inspirations",
      "milestones": "Milestones",
      "mobile_app_customer": "Mobile App Customer",
      "multilingual": "Multilingual",
      "project_partners": "Projects: partners",
      "project_subdomains": "Projects: subdomains",
      "proposal_choice_lists": "Decisions: choice lists",
      "proposal_subchoices": "Decisions: subchoices",
      "proposal_templates": "Decisions: proposal templates",
      "sales": "Sales",
      "sales_partners": "Sales: partners",
      "snippets": "Snippets",
      "surveys": "Surveys",
      "template_projects": "Projects: templates",
      "ticket_categories": "Conversations: categories",
      "tickets": "Conversations",
      "todos": "Tasks",
      "todos_v2": "Tasks v2",
      "workflows_full": "Workflows: full",
      "workflows_milestones": "Workflows: milestones",
      "workflows_tasks": "Workflows: tasks"
    }
  }
}
